export default "/_next/static/images/iosAppTablet-7cf9601a677b78b72f4963210c5f13d3.png";